














































import { Vue, Component, Prop } from 'vue-property-decorator';

import { Surface, Typography, Picture } from '@/components/atoms';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import CoinNetworkFeatureTag from '@/componentsV2/atoms/CoinNetworkFeatureTag/CoinNetworkFeatureTag.vue';
import BillingModel from '@/views/Models/BillingModel.vue';

@Component({
  components: {
    Surface,
    Typography,
    Picture,
    FilledButton,
    CoinNetworkFeatureTag
  }
})
export default class SellCoinsEmptyState extends BillingModel {
  @Prop() loadingBtn?: boolean;

  get isMobileDevice() {
    return this.$mobileCheck();
  }

  get tPrefix() {
    return 'sellCoins.emptyState';
  }

  get btnText() {
    return this.$t(
      `${this.tPrefix}.btn${this.inactiveBilling ? 'Billing' : ''}`
    );
  }

  get businessInfo() {
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }
}
